// Mirrors Nut_Controller_Plugin_AccountCheck::$controllersUsableInArrears (library/Nut/Controller/Plugin/AccountCheck.php)
// Note: /setup/user is intentionally allowed so admins on an expired trial can disable
// extra users before checking out with a smaller seat count (matches the "Users & teams"
// link exposed in ADMINISTRATION_DISABLED_SECTION of settings-nav-new.tsx).
const PATHS_ALLOWED_WHEN_EXPIRED = [
    '/setup/billing',
    '/setup/user',
    '/my-account',
    '/no-access',
    '/auth/',
    '/sales-demo',
];

/**
 * Checks if the given path is allowed when the account is expired.
 * Used by the declarative <Redirect> in app-routes.tsx.
 */
export function isPathAllowedWhenExpired(pathname: string): boolean {
    return PATHS_ALLOWED_WHEN_EXPIRED.some((p) => pathname.startsWith(p));
}
